/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from 'react-lottie';

import { ContainerStudies, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';
import ButtonAction from '../../../components/ButtonAction/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';
import ModalAdd from '../../../components/Modals/ModalAdd/index.js';
import ModalEdit from '../../../components/Modals/ModalEdit/index.js';

const EnergyFlagList = () => {
  document.title = 'Enermerco - Bandeira Tarifária';

  const [isLoading, setIsLoading] = useState(true);

  const [energyFlagList, setEnergyFlagList] = useState([]);

  const [idDm004, setIdDm004] = useState('');
  const [modalStatus, setModalStatus] = useState('');
  const [energyFlagName, setEnergyFlagName] = useState('');

  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalEnergyFlagDesc, setModalEnergyFlagDesc] = useState('');
  const [modalNumber1, setModalNumber1] = useState('');
  const [modalNumber2, setModalNumber2] = useState('');

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const applyFilter = (idDm004, energyFlagName) => {
    let url = 'energy_flag?';
    if (idDm004 !== '') {
      url += `&id=${idDm004}`;
    }
    if (energyFlagName !== '') {
      url += `&bandeira=${energyFlagName}`;
    }
    api
      .get(url)
      .then((response) => {
        setEnergyFlagList(response.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchFilter = useCallback(() => {
    applyFilter(idDm004, energyFlagName);
  }, [idDm004, energyFlagName]);

  const cleanFields = useCallback(() => {
    setIdDm004('');
    setEnergyFlagName('');
    applyFilter('', '');
  }, [idDm004, energyFlagName]);

  const deleteEnergyFlag = useCallback(
    (id) => {
      console.log(id);
      api
        .delete(`energy_flag?id=${id}`)
        .then((response) => {
          setModalDelete(false);
          if (response.status === 200) {
            toast.success('Bandeira removida com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          cleanFields();
          setModalDelete(false);
          toast.success(error);
        });
    },
    [modalDelete]
  );

  const addEnergyFlag = useCallback(
    (modalText, modalNumber1, modalNumber2, _modalNumber3) => {
      api
        .post(`energy_flag`, {
          NM_BANDEIRA: modalText.toUpperCase(),
          VL_ADICIONAL: parseFloat(modalNumber1.replace(',', '.')),
          PR_DESCONTO: parseFloat(modalNumber2.replace(',', '.').replaceAll('%', ''))
        })
        .then((response) => {
          setModalAdd(false);
          if (response.status === 201) {
            toast.success('Bandeira adicionada com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalAdd(false);
          toast.success(error);
        });
    },
    [modalAdd]
  );

  const editEnergyFlag = useCallback(
    (modalText, modalNumber1, modalNumber2, _modalNumber3, id, modalStatus) => {
      api
        .put(`energy_flag?id=${id}`, {
          NM_BANDEIRA: modalText.toUpperCase(),
          VL_ADICIONAL: parseFloat(modalNumber1.replace(',', '.')),
          PR_DESCONTO: parseFloat(modalNumber2.replace(',', '.').replaceAll('%', ''))
        })
        .then((response) => {
          setModalEdit(false);
          if (response.status === 201) {
            toast.success('Registro alterado com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalEdit(false);
          toast.success(error);
        });
    },
    [modalEdit]
  );

  useEffect(() => {
    applyFilter(idDm004, energyFlagName);
  }, []);

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando Bandeiras Tarifárias...</h1>
        </ContainerLoading>
      ) : (
        <Container>
          <ContainerStudies>
            <h2>Lista de Bandeiras Tarifárias</h2>
            <ButtonDefault
              Width={'150px'}
              Margin={'0px 30px 30px 0px'}
              Text="Adicionar"
              onClick={() => {
                setModalAdd(true);
              }}
            />
            <h3>Filtros</h3>
            <Row>
              <Col xs={3}>
                <InputDefault
                  placeholder="Código da Bandeira Tarifária"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Código'}
                  value={`${idDm004}`}
                  onChange={(e) => setIdDm004(e.target.value)}
                />
              </Col>
              <Col xs={6}>
                <InputDefault
                  placeholder="Nome da Bandeira Tarifária"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Nome'}
                  value={`${energyFlagName}`}
                  onChange={(e) => setEnergyFlagName(e.target.value)}
                />
              </Col>
            </Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Buscar"
              onClick={searchFilter}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Limpar"
              onClick={() => {
                cleanFields();
              }}
            />
            <Table striped bordered hover variant="light">
              <thead>
                <tr>
                  <th style={{ width: '5%', textAlign: 'right' }}>Código</th>
                  <th style={{ width: '30%' }}>Nome da Bandeira Tarifária</th>
                  <th style={{ width: '5%', textAlign: 'right' }}>Valor adicional</th>
                  <th style={{ width: '5%', textAlign: 'center' }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {energyFlagList.map((energyFlag) => (
                  <tr>
                    <td style={{ textAlign: 'right' }}>{energyFlag.ID_DM004}</td>
                    <td>{energyFlag.NM_BANDEIRA}</td>
                    <td style={{ textAlign: 'right' }}>
                      {Number(energyFlag.VL_ADICIONAL).toFixed(2).replace('.', ',')}
                    </td>
                    <td
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '45px',
                        justifyContent: 'center'
                      }}>
                      <ButtonAction
                        Action="Edit"
                        onClick={() => {
                          setIdDm004(energyFlag.ID_DM004);
                          setModalEnergyFlagDesc(energyFlag.NM_BANDEIRA);
                          setModalNumber1(
                            Number(energyFlag.VL_ADICIONAL).toFixed(2).replace('.', ',')
                          );
                          setModalNumber2(
                            Number(energyFlag.PR_DESCONTO).toFixed(2).replace('.', ',')
                          );
                          setModalEdit(true);
                        }}
                      />
                      <ButtonAction
                        Action="Remove"
                        onClick={() => {
                          setIdDm004(energyFlag.ID_DM004);
                          setModalEnergyFlagDesc(energyFlag.NM_BANDEIRA);
                          setModalDelete(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ContainerStudies>
          <ToastContainer />
          <ModalDelete
            modalOpen={modalDelete}
            handleClose={() => setModalDelete(false)}
            handleConfirm={deleteEnergyFlag}
            handleCancel={() => setModalDelete(false)}
            modalTitleText={`Deseja excluir a Bandeira #${idDm004}?`}
            modalText={modalEnergyFlagDesc}
            id={idDm004}
          />
          <ModalAdd
            modalOpen={modalAdd}
            handleClose={() => setModalAdd(false)}
            handleConfirm={addEnergyFlag}
            handleCancel={() => setModalAdd(false)}
            modalTitleText={'Adicionar nova Bandeira'}
            modalText={modalEnergyFlagDesc}
            visibleText={true}
            visibleNumber1={true}
            visibleNumber2={true}
            placeHolderText={'Nome'}
            textLabel={'Nome da Bandeira'}
            number1Label={'Valor adicional'}
            number2Label={'Porcentagem de desconto'}
            placeHolderNumber1={'Valor adicional'}
            numberLabel1={'Valor adicional'}
            placeHolderNumber2={'Porcentagem de desconto'}
            numberLabel2={'Porcentagem de desconto'}
          />
          <ModalEdit
            modalOpen={modalEdit}
            handleClose={() => setModalEdit(false)}
            handleConfirm={editEnergyFlag}
            handleCancel={() => setModalEdit(false)}
            modalTitleText={`Editar Distribuidora #${idDm004}`}
            visibleText={true}
            visibleNumber1={true}
            visibleNumber2={true}
            textLabel={'Nome da Distribuidora'}
            id={idDm004}
            setModalText={setModalEnergyFlagDesc}
            modalText={modalEnergyFlagDesc}
            number1Label={'Valor adicional'}
            number2Label={'Porcentagem de desconto'}
            modalNumber1={modalNumber1}
            setModalNumber1={setModalNumber1}
            modalNumber2={modalNumber2}
            setModalNumber2={setModalNumber2}
            modalNumber3={''}
            setModalNumber3={() => {}}
          />
          <Footer />
        </Container>
      )}
    </>
  );
};

export default EnergyFlagList;
